var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "6px",
    viewBox: "0 0 31 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ajouter-objet---obligatoire",
    transform: "translate(-495.000000, -47.000000)",
    fill: "#008BD2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav/header",
    transform: "translate(0.193062, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(489.500913, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/wave-copy",
    transform: "translate(6.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,6 C27.92,6 26.84,4.65 26.04,3.675 C25.28,2.7375 24.88,2.25 24,2.25 C23.12,2.25 22.72,2.7375 21.96,3.675 C21.16,4.65 20.12,6 18,6 C15.92,6 14.84,4.65 14.04,3.675 C13.28,2.7375 12.88,2.25 12,2.25 C11.12,2.25 10.72,2.7375 9.96,3.675 C9.16,4.65 8.12,6 6,6 C3.92,6 2.84,4.65 2.04,3.675 C1.28,2.7375 0.88,2.25 0,2.25 L0,0 C2.08,0 3.16,1.35 3.96,2.325 C4.72,3.2625 5.12,3.75 6,3.75 C6.84,3.75 7.28,3.2625 8.04,2.325 C8.84,1.35 9.88,0 12,0 C14.12,0 15.16,1.35 15.96,2.325 C16.72,3.2625 17.12,3.75 18,3.75 C18.84,3.75 19.28,3.2625 20.04,2.325 C20.84,1.35 21.88,0 24,0 C26.08,0 27.16,1.35 27.96,2.325 C28.72,3.2625 29.12,3.75 30,3.75 L30,6 Z",
    id: "Path-Copy",
    transform: "translate(15.000000, 3.000000) scale(1, -1) translate(-15.000000, -3.000000) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderActive);
export default __webpack_public_path__ + "static/media/header-active.46a83b138c9c87950185b16e7a6b0245.svg";
export { ForwardRef as ReactComponent };